module.exports = __webpack_public_path__ + "img/adas_dimensions_1.02305122.png";